import { TS_EarlyBird }         from '../TravelSeller/Models/TS_EarlyBird';
import { BookingItemInterface } from './BookingItemInterface';

export class EarlyBird extends TS_EarlyBird implements BookingItemInterface {
}